import React from 'react';
import PropTypes from 'prop-types';

function H3HeaderText({ title, className, textColor, textAlign, fontWeight }) {
  return <h3 className={`${textColor} ${textAlign} ${fontWeight} ${className && className}`}>{title}</h3>;
}

export default H3HeaderText;

H3HeaderText.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  textColor: PropTypes.string,
  textAlign: PropTypes.string
};

H3HeaderText.defaultProps = {
  textColor: 'text-gray-700',
  textAlign: 'text-left',
  fontWeight: 'text-bold'
};
